import React from "react";
import { Icon, SimpleGrid } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import FilledTab from "components/FilledTab";
import useTranslate from "hooks/useTranslate";
import StoreIcon from "components/StoreIcon";
import WardrobeIcon from "components/WardrobeIcon";
import BearIcon from "components/BearIcon";

const menuLinks = [
  {
    to: "/bears",
    key: "tabs:bears",
    icon: BearIcon,
  },
  {
    to: "/store",
    key: "tabs:store",
    icon: StoreIcon,
  },
  {
    to: "/wardrobe",
    key: "tabs:wardrobe",
    icon: WardrobeIcon,
  },
];

const MainMenu: React.FC = () => {
  const translate = useTranslate();

  return (
    <SimpleGrid columns={3}>
      {menuLinks.map(({ to, key, icon }) => (
        <NavLink key={to} to={to}>
          {({ isActive }) => (
            <FilledTab
              leftIcon={<Icon as={icon} w="6" h="6" />}
              size="lg"
              isActive={isActive}
            >
              {translate(key)}
            </FilledTab>
          )}
        </NavLink>
      ))}
    </SimpleGrid>
  );
};

export default MainMenu;
